import React from 'react';
import { emptyContact } from 'services/contact';
import { loadArtwork } from 'services/artQr';
import classes from './ContentOptions.module.css';

const fields = [
    ['firstName', 'Имя', 'text', 'given-name'], ['lastName', 'Фамилия', 'text', 'family-name'],
    ['middleName', 'Отчество', 'text', 'additional-name'],
    ['phone', 'Телефон', 'tel', 'tel'], ['email', 'Email', 'email', 'email'],
    ['organization', 'Компания', 'text', 'organization'], ['title', 'Должность', 'text', 'organization-title'],
    ['website', 'Сайт', 'url', 'url'],
];
export function ContactOptions({ value, setValue }) {
    return <div className={classes.wrapper}>
        <div className={classes.segment} aria-label="Содержимое QR">
            {[['url', 'Ссылка / текст'], ['contact', 'Контакт']].map(([key, label]) =>
                <button key={key} type="button" aria-pressed={value.contentType === key} onClick={() => setValue(old => ({ ...old, contentType: key, qrCodeSize: key === 'contact' && old.qrCodeSize < 600 ? 600 : old.qrCodeSize }))}>{label}</button>)}
        </div>
        {value.contentType === 'contact' && <>
            <div className={classes.fields}>{fields.map(([key, label, type, autoComplete]) => <label key={key}>{label}
                <input type={type} autoComplete={autoComplete} maxLength={key === 'website' ? 200 : 100} value={value.contact[key]}
                    onChange={e => { const text = e.target.value; setValue(old => ({ ...old, contact: { ...emptyContact, ...old.contact, [key]: text } })); }} />
            </label>)}</div>
            <p className={classes.hint}>После сканирования телефон предложит сохранить контакт. Добавление нужно подтвердить на телефоне.</p>
        </>}
    </div>;
}
export function AppearanceOptions({ value, setValue }) {
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const upload = async (file?: File) => {
        if (!file) return;
        setError('');
        if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
            setError('Выберите PNG, JPEG или WebP до 10 МБ.'); return;
        }
        setLoading(true);
        const source = URL.createObjectURL(file);
        try {
            const image = await loadArtwork(source);
            if (image.naturalWidth * image.naturalHeight > 32000000) throw new Error('Изображение слишком большое. Уменьшите его до 32 мегапикселей.');
            const canvas = document.createElement('canvas');
            const scale = Math.min(1, 1024 / Math.max(image.naturalWidth, image.naturalHeight));
            canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
            canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
            canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
            const artwork = canvas.toDataURL('image/png');
            setValue(old => ({ ...old, artwork, artworkName: file.name }));
        } catch (err) { setError(err.message || 'Не удалось загрузить изображение.'); }
        finally { URL.revokeObjectURL(source); setLoading(false); }
    };
    return <div className={classes.wrapper}>
        <div className={classes.segment} aria-label="Внешний вид QR">
            {[['standard', 'Обычный'], ['custom', 'Свои узоры'], ['art', 'Изображение']].map(([key, label]) =>
                <button key={key} type="button" aria-pressed={value.renderMode === key} onClick={() => setValue(old => ({ ...old, renderMode: key, qrCodeSize: key !== 'standard' && old.qrCodeSize < 500 ? 600 : old.qrCodeSize }))}>{label}</button>)}
        </div>
        {value.renderMode === 'custom' && <div className={classes.segment} aria-label="Узор точек">
            {[['dots', '● Точки'], ['diamond', '◆ Ромбы'], ['bars', '▥ Полоски']].map(([key, label]) =>
                <button key={key} type="button" aria-pressed={value.customPattern === key} onClick={() => setValue(old => ({ ...old, customPattern: key }))}>{label}</button>)}
        </div>}
        {value.renderMode === 'art' && <>
            <label className={classes.upload} onDragOver={e => e.preventDefault()} onDrop={e => { e.preventDefault(); if (!loading) upload(e.dataTransfer.files[0]); }}>
                {value.artwork && <img src={value.artwork} alt="Изображение для QR" />}
                <span>{loading ? 'Загрузка…' : value.artworkName || 'Выберите или перетащите изображение'}</span>
                <input type="file" aria-label="Изображение для QR" accept="image/png,image/jpeg,image/webp" disabled={loading}
                    onChange={e => { upload(e.target.files?.[0]); e.target.value = ''; }} />
            </label>
            {value.artwork && <button type="button" onClick={() => setValue(old => ({ ...old, artwork: null, artworkName: '' }))}>Удалить изображение</button>}
            <label className={classes.strength}>Яркость изображения: {value.artStrength}%
                <input type="range" min="10" max="100" step="5" value={value.artStrength} onChange={e => { const artStrength = Number(e.target.value); setValue(old => ({ ...old, artStrength })); }} />
            </label>
            <p className={classes.hint}>Картинка становится частью узора. QR хранит выбранную ссылку или контакт. Изображение обрабатывается в браузере.</p>
        </>}
        {value.renderMode !== 'standard' && <p className={classes.hint}>В этом режиме используются контрастные точки и белый фон. Настройки обычного QR сохраняются при переключении.</p>}
        {error && <p role="alert" className={classes.error}>{error}</p>}
    </div>;
}
